import React from 'react';
import { Typography } from 'antd';
import { WarningOutlined } from '@ant-design/icons';
import { NotSupportedFieldContainer } from '../styles';
import { useDictionaryTranslation } from '../../../hooks/useDictionaryTranslation';

export const NotSupportedField = () => {
  const { translate: t } = useDictionaryTranslation();

  return (
    <NotSupportedFieldContainer>
      <WarningOutlined height="30px" />
      <Typography.Text type="secondary">{t('notSupportedField')}</Typography.Text>
    </NotSupportedFieldContainer>
  );
};
